import { Clickable, Col, Icon, Row } from 'components';
import mime from 'mime';
import { useEffect, useRef, useState } from 'react';
import ReactPlayer from 'react-player';
import styled from 'styled-components';

const Image = styled.img`
  /* max-width: 468px; 
   max-height: 600px;   */
  display: block;
  height: 100%;
  width: 100%;
  object-fit: contain;
  height: ${(props) => props.ht || 'auto'};
`;

const Images = (props) => {
  const { data, isMobile } = props;
  const scrollRef = useRef(null),
    [selected, setSelected] = useState(0);

  useEffect(() => {
    scrollRef.current
      .getElementsByClassName(`scroll-image-${selected}`)[0]
      ?.scrollIntoView({ behavior: 'smooth', inline: 'start' });
  }, [selected]);

  function scroll(direction) {
    setTimeout(() => {
      setSelected(selected + direction);
    }, 10);
  }

  return (
    <Col
      noFlex
      wid={isMobile ? '90vw' : '468px'}
      // ht='60vh'
      ht="100%"
      center
      pos="relative"
    >
      {selected !== 0 && (
        <Clickable onClick={() => scroll(-1)}>
          <Row
            top="calc(50% - 17px)"
            pos="absolute"
            left="8px"
            pad="8px"
            hasRadius="32px"
            bg="rgba(255, 255, 255, 0.6)"
            className="mediaNavigator"
          >
            <Icon type="arrowLeft" dimensions={18} />
          </Row>
        </Clickable>
      )}

      {selected !== data.length - 1 && (
        <Clickable onClick={() => scroll(1)}>
          <Row
            top="calc(50% - 17px)"
            right="8px"
            pos="absolute"
            pad="8px"
            hasRadius="32px"
            bg="rgba(255, 255, 255, 0.6)"
            className="mediaNavigator"
          >
            <Icon type="arrowRight" dimensions={18} />
          </Row>
        </Clickable>
      )}

      <Row start center ref={scrollRef} style={{ overflow: 'hidden' }} ht="100%">
        {data.map((x, i) => (
          <Col
            key={i}
            center
            noFlex
            wid={isMobile ? '90vw' : '468px'}
            className={`scroll-image-${i}`}
            style={{ flexShrink: 0 }}
            // ht={isMobile ? '50vh': '600px'}
          >
            {mime.getType(x.uri)?.includes('video') ? (
              <ReactPlayer
                url={x.uri}
                width={isMobile ? '90vw' : '468px'}
                controls
                playing
                playsinline={true}
              />
            ) : (
              <Image
                src={x.uri}
                style={{ height: data?.length > 1 && isMobile ? '280px' : '100%' }}
                {...props}
              />
            )}
          </Col>
        ))}
      </Row>
    </Col>
  );
};

export default Images;
